import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  serial_id: Yup.string().required("Serial id is required"),
  plant: Yup.string().required(),
});

const EklokForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <EditText {...props} label={t("create_eklok.name")} name="name" />
          <EditText
            {...props}
            label={t("create_eklok.serial_id")}
            name="serial_id"
          />
          <Box my={2}>
            <Submit {...props} title={t("create_eklok.save")} />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default EklokForm;
